import { combineEpics } from 'redux-observable';
import { filter, mergeMap, tap } from 'rxjs/operators';

import { CLIENT_PORTAL_URL } from '../../env';
import { Services } from '../../services';
import { gotoClientPortal, gotoVerifyApp, gotoCreditApp } from '../../store/actions/route';
import { RootEpic } from '../../store/epics';
import { isEmbedded } from '../../utils/embedded';

const getEmbeddedClientPortalBaseUrl = (location: Location): string => {
  const [firstLabel, ...rest] = location.hostname.split('.');
  // eslint-disable-next-line regexp/no-unused-capturing-group
  if (rest.length === 0 || !/-(apply)$/.test(firstLabel)) {
    return CLIENT_PORTAL_URL;
  }

  // eslint-disable-next-line regexp/no-unused-capturing-group
  const portalLabel = firstLabel.replace(/-(apply)$/, '-portal');
  const host = [portalLabel, ...rest].join('.');
  return `${location.protocol}//${host}`;
};

const gotoClientPortalEpic: RootEpic = (action$, _state$, { window }: Services) => {
  return action$.pipe(
    filter(gotoClientPortal.match),
    tap(({ payload }) => {
      if (isEmbedded()) {
        // Forwarding to temporary embedded session for a user who already has a non-embedded account.
        const embeddedSessionToken = payload?.embeddedSessionToken;
        if (embeddedSessionToken) {
          const clientPortalBaseUrl = getEmbeddedClientPortalBaseUrl(window.location);
          const theme = new URLSearchParams(window.location.search).get('theme');
          window.location.replace(
            `${clientPortalBaseUrl}/embedded?session=${encodeURIComponent(embeddedSessionToken)}${theme ? `&theme=${encodeURIComponent(theme)}` : ''}`,
          );
        } else {
          window.open(CLIENT_PORTAL_URL, '_blank');
        }
      } else {
        window.location.replace(CLIENT_PORTAL_URL);
      }
    }),
    mergeMap(() => []),
  );
};

const gotoVerifyAppEpic: RootEpic = (action$, state$, { window }: Services) => {
  return action$.pipe(
    filter(gotoVerifyApp.match),
    tap(() => {
      window.location.replace(state$.value.config.config!.verifyAppUrl);
    }),
    mergeMap(() => []),
  );
};

const gotoCreditAppEpic: RootEpic = (action$, state$, { window }: Services) => {
  return action$.pipe(
    filter(gotoCreditApp.match),
    tap(() => {
      window.location.replace(state$.value.config.config!.creditAppUrl);
    }),
    mergeMap(() => []),
  );
};

export const gotoPortalEpic = combineEpics(gotoClientPortalEpic, gotoVerifyAppEpic, gotoCreditAppEpic);
